<template lang="pug">
div(v-if="!embedded")
  modal-vue(
    v-show="modalVisible"
    modal_id="document_options_modal"
    :content_loaded="!loaderVisible"
    size_modal="modal-lg"
  )
    template(v-slot:header)
      | {{ t(`components.documents.options_modal.${titleKey}`) }}
    template(v-slot:body)
      include partials/options_modal_content
    template(v-slot:footer)
      include partials/options_modal_footer
  include partials/options_modal_print
  notification-modal-vue(
    :text="notificationText"
    ref="notification_modal"
    title="Email"
    data-cy="notification-modal"
  )
.content-wrapper(v-else)
  .modal-body
    .modal-container
      include partials/options_modal_content

  .modal-footer
    include partials/options_modal_footer
  include partials/options_modal_print

  loader-vue(v-if="loaderVisible" :visible="true")
</template>

<script>
import ApiClient from 'common/ApiClient'
import mixins from 'common/mixins'
import filters from 'common/filters.js'

const ALL_PARTS = 'all_parts'

export default {
  name: 'documents-options-modal-vue',
  mixins: [mixins.translate, mixins.requests],
  filters: {
    remove_intro_chars: filters.remove_intro_chars
  },
  props: {
    visibleOptions: { type: Array, default: () => ['download', 'print', 'share'] },
    downloadFormats: { type: Array, default: () => ['pdf', 'docx', 'html'] },
    embedded: { type: Boolean, default: false },
    loadingData: { type: Boolean, default: false },
    selectedOption: { type: String, default: 'download' },
    id: { type: Number, default: 0 },
    numeroTol: { type: String, default: '' },
    clazz: { type: String, default: '' },
    headerFields: { type: Array, default: () => [] },
    indiceFields: { type: Array, default: () => [] },
    bodyFields: { type: Array, default: () => [] },
    fileFields: { type: Array, default: () => [] },
    metadataFields: { type: Array, default: () => [] }
  },
  components: {
    'modal-vue': () => import(/* webpackChunkName: "[request]" */ 'components/Modal'),
    'loader-vue': () => import(/* webpackChunkName: "[request]" */ 'components/Loader'),
    'forms-autocomplete-tree-selector-vue': () => import(/* webpackChunkName: "[request]" */ "components/forms/AutocompleteTreeSelector"),
    'notification-modal-vue': () => import(/* webpackChunkName: "[request]" */ "components/NotificationModal"),
    'resumen-ia-vue': () => import(
      /* webpackChunkName: "[request]" */ 'components/documents/ResumenIa'
    ),
  },
  data() {
    return {
      modalVisible: false,
      selectedDownloadFormat: 'pdf',
      currentSelectedOption: this.selectedOption,
      modalError: '',
      fileName: (this.numeroTol || '').replace(/\./g, ''),
      selectedSections: [],
      shareMail: '',
      shareText: '',
      loadingFile: false,
      fileId: '',
      notificationText: ''
    }
  },
  computed: {
    hasFileFields() {
      return (this.fileFields || []).length > 0
    },
    sectionsSelectorVisible() {
      return (!this.hasFileFields || this.currentSelectedOption == 'print') && this.bodyFields.length > 0
    },
    downloadFormat() {
      if (this.hasFileFields)
        return ''

      return this.selectedDownloadFormat
    },
    printContainerIdSelector() {
      return `#${this.printContainerId}`
    },
    printContainerId() {
      return `print_container_${this.id}`
    },
    documentParts() {
      var self = this
      var path = [{ id: ALL_PARTS, name: this.t('components.documents.options_modal.all_parts'), children: [] }]
      if (this.indiceFields.length > 0) {
        this.indiceFields.forEach(function (indice) {
          var node = { id: indice.id, name: indice.label, children: [] }
          var parent = path[indice.depth - 1]
          
          if (!parent) {
            console.warn(`Índice inválido: depth=${indice.depth}, path.length=${path.length}`)
            return
          }
          parent.children.push(node)
          path.splice(indice.depth, path.length - 1)
          path.push(node)
        })
        this.bodyFields.forEach(function (field) {
          if (!self.indiceFields.some(function (indice) { return field.id == indice.id }))
            path[0].children.push({ id: field.id, name: field.label, children: [] })
        })

      } else {
        path[0].children = this.bodyFields.map((field) => { return { id: field.id, name: field.label, children: [] } })
      }
      path[0].name += ` (${path[0].children.length})`
      return [path[0]]
    },
    errorVisible() {
      return this.modalError !== ""
    },
    loaderVisible() {
      return this.loadingFile || this.loading || this.loadingData
    },
    paramsForGetFile() {
      var params = { type: this.currentSelectedOption }
      if (this.currentSelectedOption == 'download') {
        params.download_format = this.downloadFormat
        params.name = this.fileName
      }
      else if (this.currentSelectedOption == 'share') {
        params.mail = this.shareMail
        params.text = this.shareText
        params.numeroTOL = this.numeroTol
      }
      return params
    },
    tabsVisible() {
      return this.visibleOptions.length > 1
    },
    titleKey() {
      return this.tabsVisible ? 'title' : `options.${this.selectedOption}`
    },
    clazzLabel() {
      return this.t(`document_clazz.${this.clazz.toLowerCase()}`)
    },
    resumenIa() {
      var documentCard = this.metadataFields.find(field => field.id == 'document_card')

      return ((documentCard || {}).values || []).find(field => field.id == 'resumen') || {}
    },
  },
  methods: {
    download() {
      if (this.clazz == 'bibliotecavirtual') {
        this.downloadBibliotecaVirtualFile()
      } else {
        this.createFile()
      }
    },
    share() {
      if (this.validEmail()) {
        this.selectedDownloadFormat = 'pdf'
        if (this.clazz == 'bibliotecavirtual') {
          this.shareBibliotecaVirtualFile()
        } else {
          this.createFile()
        }
      }
    },
    createFile() {
      this.loadingFile = true
      this.modalError = ""
      this.http_post({
        url: this.url_for_document_file_create(),
        params: {
          'docid': this.id,
          'download_format': this.downloadFormat,
          'body_fields': this.selectedSections.filter((value) => { return value != ALL_PARTS })
        },
        success: this.handleFileCreated
      })
    },
    handleFileCreated(response) {
      var self = this
      if (response.bodyText) {
        self.fileId = response.bodyText
        setTimeout(function () { self.tryGetFile() }, 2000);
      } else {
        alert('Error al crear el fichero')
      }
    },
    tryGetFile() {
      this.http_get({
        url: this.url_for_document_file_show(this.fileId, this.paramsForGetFile),
        success: this.tryGetFileCallback,
        fail: this.tryGetFileErrorCallback
      })
    },
    tryGetFileCallback(response) {
      var self = this
      if (response.data) {
        if (this.currentSelectedOption == 'download'){
          window.location = this.url_for_document_file_show(this.fileId, this.paramsForGetFile)
          this.loadingFile = false
        } else if (this.currentSelectedOption == 'share'){
          this.loadingFile = false
          this.notificate(this.t('components.documents.options_modal.share.sent'))
          this.hideModal()
        }
      } else {
        setTimeout(function () { self.tryGetFile() }, 2000);
      }
    },
    tryGetFileErrorCallback(response) {
      this.loadingFile = false
      this.modalError = response.body[0]
    },
    selectAllSections(bodyFields) {
      var sections = bodyFields.map((field) => { return field.id })
      sections.push(ALL_PARTS)
      this.selectedSections = sections.slice()
    },
    showModal() {
      this.modalVisible = true
    },
    hideModal() {
      this.modalVisible = false
      var event = new CustomEvent('options-modal:close')
      document.dispatchEvent(event)
    },
    selectOption(option) {
      this.currentSelectedOption = option
    },
    calculateIndiceFieldClass(field) {
      return `depth_${field.depth}`
    },
    calculateIndiceFieldRef(field) {
      return `#${field.id}`
    },
    validEmail(){
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      var valid = emailRegex.test(this.shareMail)
      if (!valid) {
        this.notificate(this.t('components.documents.options_modal.share.validations.not_valid'))
        return false
      }

      return true
    },
    notificate(message) {
      this.notificationText = message
      let notificationModalRef = this.$refs.notification_modal

      if (Array.isArray(notificationModalRef)){
        notificationModalRef = notificationModalRef[0]
      }
      if (notificationModalRef && typeof notificationModalRef.show === 'function') {
        notificationModalRef.show()
      } else {
        console.warn("No se pudo cerrar el modal")
        this.hideModal()
      }
    },
    downloadBibliotecaVirtualFile() {
      let baseUrl = gon.url_for.biblioteca_virtual_file_show_url.replace(':id', this.id)
      let params = new URLSearchParams()
      params.append('type', 'download')
      params.append('name', this.fileName)
      window.location.assign(`${baseUrl}?${params}`)
    },
    async shareBibliotecaVirtualFile() {
      const api = new ApiClient()
      let baseUrl = gon.url_for.biblioteca_virtual_file_show_url.replace(':id', this.id)
      let params = new URLSearchParams()
      params.append('type', 'share')
      params.append('mail', this.shareMail)
      params.append('text', this.shareText)

      const response = await api.get(`${baseUrl}?${params}`)
      this.loadingFile = false

      if (response.ok) {
        this.notificate(this.t('components.documents.options_modal.share.sent'))
      } else {
        this.notificate(this.t('components.documents.options_modal.share.error'))
      }
      this.hideModal()
    }
  },
  watch: {
    bodyFields(val) {
      this.selectAllSections(val)
    }
  },
  created() {
    this.selectAllSections(this.bodyFields)
  },
}
</script>
